<template>
  <b-modal id="modalMotivoAlteracao"
           ref="modalMotivoAlteracao"
           centered
           title="Motivo da alteração">
    <ul class="unorderedList">
      <li v-for="(motivo, index) in motivos"
          :key="index">
        <div class="form-group">
          <span class="custom-control custom-radio custom-control-inline">
            <input :id="`motivo-alteracao_${motivo.codigo}`"
                   v-model="codigoAlteracao"
                   :value="motivo.codigo"
                   type="radio"
                   :name="`motivo-alteracao_${motivo.codigo}`"
                   class="custom-control-input">
            <label class="custom-control-label"
                   :for="`motivo-alteracao_${motivo.codigo}`">
              {{ motivo.text }}
            </label>
          </span>

          <div class="row">
            <div v-if="((codigoAlteracao === 20) && (index === 1)) || ((codigoAlteracao === 50) && (index === 2))"
                 class="col-12">
              <div>
                <label class="titulo-data-averbacao"
                       for="data_averbacao">Digite a data de averbação</label>
                <input id="data_averbacao"
                       v-model="dataAverbacao"
                       v-validate="`required|date_format:yyyy-MM-dd|date_between:1500-01-01,${ dataLimite() }, (include)`"
                       :class="{ 'is-invalid': errors.has('date') }"
                       class="form-control form-control-sm col-md-4"
                       name="date"
                       required
                       type="date">
                <small v-if="errors.has('date')"
                       class="invalid-feedback">{{ errors.first('date') }}</small>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div slot="modal-footer"
         slot-scope="{ ok, cancel }"
         class="modalEditFilho_footer">
      <button class="btn btn-sm btn-dark mr-2"
              @click="$root.$emit('bv::hide::modal', 'modalMotivoAlteracao')">
        Voltar
      </button>
      <button class="btn btn-sm btn-primary"
              type="button"
              :disabled="!codigoAlteracao || ([20, 50].indexOf(codigoAlteracao) != -1 && !dataAverbacao)"
              @click="save()">
        Gravar Atualização
      </button>
    </div>
  </b-modal>
</template>

<script>
  import moment from "moment"

  export default {
    props: {
      tipo: {
        type: String,
        required: true
      },
      tarefaAlteracaoCarga: {
        type: Object,
        default: () => {}
      }
    },
    data () {
      return {
        codigoAlteracao: '',
        dataAverbacao: '',
        listMotivos: [
          {
            text: 'Erro do cartório na digitação da carga',
            codigo: 10
          },
          {
            text: 'Retificação',
            codigo: 20
          },
          {
            text: 'Reconhecimento de paternidade',
            codigo: 50
          },
          {
            text: 'Complementação de informações',
            codigo: 60
          },
          {
            text: 'Retirar da consulta externa da CRC (Determinação Judicial)',
            codigo: 30
          },
          {
            text: 'Não envia carga CRC',
            codigo: 99
          }

        ],
        limitDate: moment(new Date()).add(1, 'day').format('DD/MM/YYYY')
      }
    },
    computed: {
      motivos () {
        if (this.tipo === 'O' || this.tipo === 'C') {
          const motivos = this.listMotivos
          motivos.splice(2, 1)
          return motivos
        }
        return this.listMotivos
      }
    },
    methods: {
      save () {
        this.$validator.validate().then(async resp => {

          let continuarUpdate = true

          // Se o motivo da alteração for "Não enviar carga CRC"
          if (this.codigoAlteracao === 99) {
            if (this.tarefaAlteracaoCarga) {
              objSwal.question.title = 'Ao alterar para esta opção a tarefa de alteração de carga será excluída.'
            } else {
              objSwal.question.title = ''
            }
            objSwal.question.text = 'Tem certeza que deseja continuar?'
            objSwal.question.cancelButtonText = 'Não'
            objSwal.question.confirmButtonText = 'Sim'

            await Swal.fire(objSwal.question).then(resp => {
              if (!resp.value) continuarUpdate = false
            })
          }

          if (!continuarUpdate) return

          if (resp) {
            this.$emit('gravarAtualizacao', {
              codigo: this.codigoAlteracao,
              dataAverb: this.dataAverbacao ? moment(this.dataAverbacao).format("YYYY-MM-DD") : null
            })
          }
        })
      },
      dataLimite () {
        return moment(new Date()).format("YYYY-MM-DD")
      },
    }
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/_exports';
  @import '../../../scss/_components/resumos';

  .unorderedList {
    @extend %resetList;
  }

  .titulo-data-averbacao {
    font-weight: normal;
    padding-top: 5px;
  }
</style>
